// extracted by mini-css-extract-plugin
export var scrollArea = "_nq-0";